import { ref, watch } from 'vue';
import CONFIG from 'Config';
import { useNotificationDataAll } from 'Store';

const { notificationAllNumberUnread } = useNotificationDataAll();
const titleContainer = ref('');

export function usePageSeo() {
  function setPageTitle(pageTitle = CONFIG.seo.defaultTitle) {
    // Save title in container to use it when notification counter is updated
    titleContainer.value = pageTitle;
    let title = `${pageTitle} | AcreTrader`;
    if (notificationAllNumberUnread.value) title = `(${notificationAllNumberUnread.value}) ${title}`;
    document.title = title;
    // setOgContents({ title });
  }

  watch(notificationAllNumberUnread, () => setPageTitle(titleContainer.value));

  return {
    setPageTitle,
  };
}
